import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useEffect } from "react";

import './App.css';

import Signup from './pages/SignupPage';
import Login from './pages/LoginPage';
import HomePage from './pages/HomePage';
import BookNookPage from './pages/BookNookPage';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './pages/MainLayout';
import StatsPage from './pages/StatsPage';
import SearchPage from './pages/SearchPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import ListView from './components/ListView';
import ShelfView from './components/ShelfView';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import Dashboard from './pages/Dashboard';

import { connectSocket, disconnectSocket } from './services/Socket';


function App() {

  // Initialize socket on app load
  useEffect(() => {
    const user_id = localStorage.getItem('user_id');
    if (user_id) {
      connectSocket(user_id);
    }

    // Cleanup socket on unmount
    return () => {
      disconnectSocket();
    };
  }, []);

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<ProtectedRoute><MainLayout><HomePage /></MainLayout></ProtectedRoute>} />
          <Route path="/home/:genre" element={<ProtectedRoute><MainLayout><ListView /></MainLayout></ProtectedRoute>} />
          <Route path="/booknook" element={<ProtectedRoute><MainLayout><BookNookPage /></MainLayout></ProtectedRoute>} />
          <Route path="/booknook/:shelfName" element={<ProtectedRoute><MainLayout><ShelfView /></MainLayout></ProtectedRoute>} />
          <Route path="/stats" element={<ProtectedRoute><MainLayout><StatsPage /></MainLayout></ProtectedRoute>} />
          <Route path="/search/" element={<ProtectedRoute><MainLayout><SearchPage /></MainLayout></ProtectedRoute>} />
          <Route path="/search/:query" element={<ProtectedRoute><MainLayout><SearchPage /></MainLayout></ProtectedRoute>} />
          <Route path="/profile/:username" element={<ProtectedRoute><MainLayout><ProfilePage /></MainLayout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><MainLayout><SettingsPage /></MainLayout></ProtectedRoute>} />

          {/* Admin-only route */}
          <Route path="/dashboard" element={<AdminProtectedRoute><MainLayout><Dashboard /></MainLayout></AdminProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
